<!--
    描述： 概算价 表格页面
    时间： xx
    created by zjj
-->
<template>
	<!-- 表格布局页面 -->
	<div class="h100 special-table">
		<vxe-table resizable
				   ref="xTree"
				   show-footer
				   height="auto"
				   auto-resize
				   border
				   size="small"
				   highlight-hover-row
				   :data="tableData"
				   :tree-config="{children: 'children', expandAll: true}"
				   :edit-config="{trigger: 'click', mode: 'cell', showStatus: false, activeMethod: activeEditMethod}"
				   :cell-class-name="cellClassName"
				   :row-class-name="rowClassName"
				   :footer-method="footerMethod"
				   @edit-actived="onEdit"
				   @edit-closed="endEdit"
				   @edit-disabled="editMessage">
			<vxe-table-column type="seq"
							  title="序号"
							  header-align="center"
							  width="80px"></vxe-table-column>
			<vxe-table-column field="sname"
							  title="项目名称"
							  header-align="center"
							  align="left"
							  min-width="150px"
							  show-overflow
							  tree-node></vxe-table-column>
			<vxe-table-column field="projectQuantity"
							  title="工程量"
							  header-align="center"
							  align="center"
							  width="120px"
							  :edit-render="{name: 'input'}">
				<template v-slot:edit="{ row }">
					<el-input size="small"
							  type="number"
							  v-model="row.projectQuantity"
							  v-if="row.levelType == 2"></el-input>
					<div v-else>{{ parseFloat(row.projectQuantity) || '' }}</div>
				</template>
				<template v-slot="{ row }">
					<div>{{ parseFloat(row.projectQuantity) || '' }}</div>
				</template>
			</vxe-table-column>
			<vxe-table-column title="费用估算（元）"
							  header-align="center">
				<vxe-table-column field="moneyBuild"
								  title="建筑工程费"
								  header-align="center"
								  gong
								  align="right"
								  width="110px"
								  :edit-render="{}">
					<template v-slot:edit="{ row }">
						<el-input size="small"
								  type="number"
								  v-model="row.moneyBuild"
								  v-if="row.levelType == 2 && row.pid !== 'S001' && row.pid !== 'S002'"></el-input>
						<div v-else>{{ parseFloat(row.moneyBuild) || 0 }}</div>
					</template>
					<template v-slot="{ row }">
						<div>{{ parseFloat(row.moneyBuild) || 0 }}</div>
					</template>
				</vxe-table-column>
				<vxe-table-column field="moneyEquipment"
								  title="设备购置费"
								  header-align="center"
								  width="110px"
								  align="right"
								  :edit-render="{name: 'input'}">
					<template v-slot:edit="{ row }">
						<el-input size="small"
								  type="number"
								  v-model="row.moneyEquipment"
								  v-if="row.levelType == 2 && row.pid !== 'S001' && row.pid !== 'S002'"></el-input>
						<div v-else>{{ parseFloat(row.moneyEquipment) || 0 }}</div>
					</template>
					<template v-slot="{ row }">
						<div>{{ parseFloat(row.moneyEquipment) || 0 }}</div>
					</template>
				</vxe-table-column>
				<vxe-table-column field="moneyInstall"
								  title="安装工程费"
								  header-align="center"
								  width="110px"
								  align="right"
								  :edit-render="{name: 'input'}">
					<template v-slot:edit="{ row }">
						<el-input size="small"
								  type="number"
								  v-model="row.moneyInstall"
								  v-if="row.levelType == 2 && row.pid !== 'S001' && row.pid !== 'S002'"></el-input>
						<div v-else>{{ parseFloat(row.moneyInstall) || 0.00 }}</div>
					</template>
					<template v-slot="{ row }">
						<div>{{ parseFloat(row.moneyInstall) || 0.00 }}</div>
					</template>
				</vxe-table-column>
				<vxe-table-column field="moneyOther"
								  title="其他费用"
								  header-align="center"
								  width="110px"
								  align="right"
								  :edit-render="{name: 'input'}">
					<template v-slot:edit="{ row }">
						<el-input size="small"
								  type="number"
								  v-model="row.moneyOther"
								  v-if="row.levelType == 2"></el-input>
						<div v-else>{{ parseFloat(row.moneyOther) || 0 }}</div>
					</template>
					<template v-slot="{ row }">
						<div>{{ parseFloat(row.moneyOther) || 0 }}</div>
					</template>
				</vxe-table-column>
				<vxe-table-column field="total"
								  title="合计"
								  header-align="center"
								  align="right"
								  width="100px">
					<template v-slot="{ row }">
						<div>{{ getSum(row) }}</div>
					</template>
				</vxe-table-column>
			</vxe-table-column>
			<vxe-table-column field="date"
							  title="经济指标"
							  align="center"
							  width="120px"></vxe-table-column>
			<vxe-table-column field="unit"
							  title="单位"
							  align="center"
							  width="120px"
							  :edit-render="{name: 'input'}">
				<template v-slot:edit="{ row }">
					<el-input size="small"
							  v-model="row.unit"
							  v-if="row.levelType == 2"></el-input>
					<div v-else>{{ row.unit }}</div>
				</template>
				<template v-slot="{ row }">
					<div>{{ row.unit }}</div>
				</template>
			</vxe-table-column>
			<vxe-table-column field="remarks"
							  title="备注"
							  align="center"
							  width="120px"
							  show-overflow
							  :edit-render="{name: 'input'}"></vxe-table-column>
		</vxe-table>
	</div>
</template>

<script>
import { saveCostBudgetDetail } from '@/api/modules/project_costfiles'
export default {
	name: 'estimate-table-index',
	props: {
		// 主要费用
		mainCost: {
			type: Array,
			default: () => {
				return []
			}
		},
		// 其他费用模块
		otherCost: {
			type: Array,
			default: () => {
				return []
			}
		},
		// 预备费 模块
		prepareCost: {
			type: Array,
			default: () => {
				return []
			}
		}
	},
	data() {
		return {
			tableData: [],
			isEdit: false,
			messageLoading: true,
			footer: {
				sname: '合计',
				moneyOther: this.totalCost
			}
		}
	},
	methods: {
		// 是否开启编辑
		activeEditMethod() {
			if (!this.isEdit) {
				this.$
				return false
			}
			return true
		},
		// 不能编辑时的提示
		editMessage({ row, column }) {
			if (this.messageLoading) {
				this.$message.info('请解锁后编辑！')
				this.messageLoading = false

				setTimeout(() => {
					this.messageLoading = true
				}, 2000)
			}
		},
		// 在编辑时
		onEdit({ row, rowIndex, $rowIndex, column }) {
			row[column.property] = parseFloat(row[column.property]) || ''
		},
		// 结束编辑--纵向汇总
		endEdit({ row, rowIndex, $rowIndex, column }) {
			if (row.levelType !== 2) {
				return
			}
			if (
				column.property !== 'moneyBuild' &&
				column.property !== 'moneyEquipment' &&
				column.property !== 'moneyInstall' &&
				column.property !== 'moneyOther'
			) {
				return
			}
			// 其他费用 和 预备费 纵向汇总
			row[column.property] = parseFloat(row[column.property]) || 0

			let num = 0,
				root = 0

			// 其他费用
			if (row.pid === 'S001') {
				// 一级汇总
				this.tableData[1].children.forEach(m => {
					root += parseFloat(m.moneyOther) || 0
				})
				this.tableData[1].moneyOther = root
				this.tableData[1].costPrice = root

				this.$emit('changeVal', row, 1)
			} else if (row.pid === 'S002') {
				// 预备费
				// 一级汇总
				this.tableData[2].children.forEach(m => {
					root += parseFloat(m.moneyOther) || 0
				})
				this.tableData[2].moneyOther = root
				this.tableData[2].costPrice = root

				this.$emit('changeVal', row, 2)
			} else {
				// 结构费
				let parent = this.tableData[0].children.find(
					x => x.id === row.pid
				)
				// 二级汇总
				parent.children.forEach(y => {
					num += parseFloat(y[column.property]) || 0
				})
				parent[column.property] = num

				// 一级汇总
				this.tableData[0].children.forEach(m => {
					root += parseFloat(m[column.property]) || 0
				})
				this.tableData[0][column.property] = root
			}

			// 更新表尾合计
			let xTree = this.$refs.xTree
			xTree.updateFooter()
		},
		// 每行合计
		getSum(row) {
			let moneyBuild = parseFloat(row.moneyBuild) || 0
			let moneyEquipment = parseFloat(row.moneyEquipment) || 0
			let moneyInstall = parseFloat(row.moneyInstall) || 0
			let moneyOther = parseFloat(row.moneyOther) || 0
			return moneyBuild + moneyEquipment + moneyInstall + moneyOther
		},
		// 列样式
		cellClassName({ row, rowIndex, column, columnIndex }) {
			if (row.levelType === 2) {
				// 其他费用 和 预备费只可编辑 其他费用
				if (row.pid === 'S001' || row.pid === 'S002') {
					if (
						column.property === 'moneyOther' ||
						column.property === 'projectQuantity' ||
						column.property === 'unit' ||
						column.property === 'remarks'
					) {
						return 'edit-bgColor'
					}
				} else {
					if (
						column.property === 'projectQuantity' ||
						column.property === 'moneyBuild' ||
						column.property === 'moneyEquipment' ||
						column.property === 'moneyInstall' ||
						column.property === 'moneyOther' ||
						column.property === 'unit' ||
						column.property === 'remarks'
					) {
						return 'edit-bgColor'
					}
				}
			}
		},
		// 行样式
		rowClassName({ row, rowIndex }) {
			if (row.levelType === 0) {
				return 'project-row'
			} else if (row.levelType === 1) {
				return 'single-row'
			} else if (row.levelType === 2) {
				return 'unit-row'
			}
			return ''
		},
		// 点击右侧表格 保存
		doSave() {
			let params = {
				costBudgets: [], // 主体费用数组
				costBudgetOthers: [] // 其他费用数组
			}
			// 主体费用
			let _main = this.tableData.find(x => x.pid === 'S000')
			if (_main && _main.children) {
				_main.children.forEach(x => {
					if (x.children && x.children.length > 0) {
						x.children.forEach(y => {
							params.costBudgets.push(y)
						})
					}
				})
			}

			// 其他费用
			let _other = this.tableData.find(x => x.uid === 'S001')
			if (_other && _other.children) {
				_other.children.forEach(x => {
					x.costPrice = parseFloat(x.moneyOther) || 0
					params.costBudgetOthers.push(x)
				})
			}

			// 预备费
			let _prepare = this.tableData.find(x => x.uid === 'S002')
			if (_prepare && _prepare.children) {
				_prepare.children.forEach(x => {
					x.costPrice = parseFloat(x.moneyOther) || 0
					params.costBudgetOthers.push(x)
				})
			}
			// return
			saveCostBudgetDetail(params).then(res => {
				if (res.code === 0) {
					let xTree = this.$refs.xTree
					xTree.syncData()
					// 回调
					this.$message.success(res.msg)
					this.$emit('onSuccess')
				}
			})
		},
		// 锁定/解锁
		doLock(status) {
			this.isEdit = !status
		},
		// 删除节点
		doDelete(node, data) {
			let xTree = this.$refs.xTree
			let _item
			if (data.costType === 1) {
				_item = this.tableData.find(x => x.uid === 'S001')
			} else {
				_item = this.tableData.find(x => x.uid === 'S002')
			}
			let _index = _item.children.findIndex(x => x.uid === data.uid)
			if (_index > -1) {
				_item.children.splice(_index, 1)
			}
			xTree.syncData()
		},
		// 表尾合计
		footerMethod({ columns, data }) {
			return [
				columns.map((column, columnIndex) => {
					if (columnIndex === 0) {
						return '合计'
					}
					switch (column.property) {
						case 'total':
							return this.totalCost
					}
					return '-'
				})
			]
		}
	},
	created() {
		// 加入主要费用
		let _mainCost = JSON.parse(JSON.stringify(this.mainCost))
		this.tableData.push(..._mainCost)

		// 加入 其他费用数组
		let _otherList = JSON.parse(JSON.stringify(this.otherCost))
		this.tableData.push(..._otherList)

		// 加入预备费
		let _prepareList = JSON.parse(JSON.stringify(this.prepareCost))
		this.tableData.push(..._prepareList)
	},
	computed: {
		// 合计
		totalCost() {
			let _main = this.tableData.find(x => x.pid === 'S000')
			let _other = this.tableData.find(x => x.uid === 'S001')
			let _prepare = this.tableData.find(x => x.uid === 'S002')

			if (_main) {
				return (
					_main.moneyBuild +
					_main.moneyEquipment +
					_main.moneyInstall +
					_main.moneyOther +
					_other.moneyOther +
					_prepare.moneyOther
				)
			}
		}
	},
	watch: {
		// 监听主要费用的变化
		mainCost: {
			handler: function(arr) {
				if (arr[0]) {
					let _index = this.tableData.findIndex(
						x => x.id === arr[0].id
					)
					if (_index > -1) {
						this.tableData.splice(_index, 1)
						let _item = JSON.parse(JSON.stringify(arr[0]))
						this.tableData.unshift(_item)
					} else {
						let _item = JSON.parse(JSON.stringify(arr[0]))
						this.tableData.unshift(_item)
					}
				}
			},
			deep: true
		},
		// 监听其他费用 的变化
		otherCost: {
			handler: function(val) {
				let _item = this.tableData.find(x => x.uid === 'S001')
				let num = 0

				_item.children = []
				let xTree = this.$refs.xTree
				val[0].children.forEach(x => {
					xTree.createRow(x).then(newRow => {
						// 插入到指定数组
						_item.children.push(newRow)
						xTree.syncData()
					})
				})

				setTimeout(() => {
					_item.children.forEach(x => {
						num += parseFloat(x.moneyOther) || 0
					})

					_item.costPrice = num
					_item.moneyOther = num

					// 更新表尾合计
					xTree.updateFooter()
				}, 500)
			},
			deep: true
		},
		// 监听 预备费 的变化
		prepareCost: {
			handler: function(arr) {
				let _item = this.tableData.find(x => x.uid === 'S002')
				let num = 0

				_item.children = []
				let xTree = this.$refs.xTree
				arr[0].children.forEach(x => {
					xTree.createRow(x).then(newRow => {
						// 插入到指定数组
						_item.children.push(newRow)
						xTree.syncData()
					})
				})

				setTimeout(() => {
					_item.children.forEach(x => {
						num += parseFloat(x.moneyOther) || 0
					})

					_item.costPrice = num
					_item.moneyOther = num

					// 更新表尾合计
					xTree.updateFooter()
				}, 500)
			},
			deep: true
		}
	}
}
</script>

<style lang="less" scoped>
</style>